module.exports = __webpack_public_path__ + "static/media/mrz-scanner.8932f880.png";